<template>
	<gui-dialog v-if="displayDialog" @click-away="closeDialog">
			<div slot="header">
				<h4>Request a Quote for Your Event</h4>
				<p>Please provide as much info as you can so we can give you an accurate quote.</p>
			</div>
			
			<form slot="body" class="gw-form" ref="quoteForm">
				<div class="gw-field-group">
					<h5 class="gw-field-group-header">Contact Info</h5>
					<!-- <label class="gw-field-group-label">Contact Info</label> -->
					<gui-input type="text" label="Name" name="name" v-model="quoteInfo.contact.name" class="label-left"></gui-input>
					<gui-input type="tel" label="Phone Number" mask="___-___-____" name="phoneNumber" v-model="quoteInfo.contact.phoneNumber" class="label-left"></gui-input>
					<gui-input type="email" label="Email" name="email" v-model="quoteInfo.contact.email" class="label-left" validate="required" error-msg="Please enter a valid email address."></gui-input>
				</div>
				
				<div class="gw-field-group">
					<h5 class="gw-field-group-header">Event Info</h5>
					<!-- <label class="gw-field-group-label">Contact Info</label> -->
					<gui-input type="date" label="Date" name="date" v-model="quoteInfo.date" class="label-left"></gui-input>
					<gui-input type="text" label="Time" name="time" v-model="quoteInfo.time" class="label-left"></gui-input>
					<!-- <input v-model="quoteInfo.time" v-validate="'required'" name="time" /> -->
					<gui-input type="text" label="Type of Event" name="eventType" v-model="quoteInfo.eventType" :options="eventTypes" class="label-left"></gui-input>
					
					<!-- if eventType === Wedding Ceremony -->
					<gui-input v-show="quoteInfo.eventType === 'Wedding Ceremony'" type="text" label="Name of Bride" name="brideName" v-model="quoteInfo.wedding.brideName" class="label-left"></gui-input>
					<gui-input v-show="quoteInfo.eventType === 'Wedding Ceremony'" type="text" label="Name of Groom" name="groomName" v-model="quoteInfo.wedding.groomName" class="label-left"></gui-input>
					
					<!-- if eventType === Other -->
					<gui-input v-show="quoteInfo.eventType === 'Other'" type="text" label="Describe Event" name="description" v-model="quoteInfo.description" class="label-left"></gui-input>

					<!-- if eventType !== Wedding Ceremony -->
					<gui-input v-show="quoteInfo.eventType && quoteInfo.eventType !== 'Wedding Ceremony'" type="text" label="How long will we be playing?" name="length" v-model="quoteInfo.length" class="label-left"></gui-input>

					<!-- if eventType === Memorial Service -->
					<label v-show="quoteInfo.eventType === 'Memorial Service'" class="gw-field-label">Select the times you want us to play (does not affect cost):</label>
					<gui-checkbox v-show="quoteInfo.eventType === 'Memorial Service'" label="Prelude (starting 30 minutes before the service)" v-model="quoteInfo.memorial.playPrelude"></gui-checkbox>
					<gui-checkbox v-show="quoteInfo.eventType === 'Memorial Service'" label="During the Service" v-model="quoteInfo.memorial.playService"></gui-checkbox>
					<gui-checkbox v-show="quoteInfo.eventType === 'Memorial Service'" label="Postlude (as people leave)" v-model="quoteInfo.memorial.playPostlude"></gui-checkbox>
					<hr v-show="quoteInfo.eventType === 'Memorial Service'" />
					<gui-checkbox v-show="quoteInfo.eventType === 'Memorial Service'" label="Undecided" v-model="quoteInfo.memorial.undecided"></gui-checkbox>

					<!--<button type="text" class="gw-btn gw-glyph" :class="dropdownClass" @click="toggleDropdown"></button>-->
				</div>
				
				<div class="gw-field-group" v-show="displayVenueFields">
					<h5 class="gw-field-group-header">Venue Info</h5>
					<gui-input type="text" label="Name" name="venueName" v-model="quoteInfo.venue.name" class="label-left"></gui-input>
					<gui-input type="text" label="Street Address" name="streetAddress" v-model="quoteInfo.venue.streetAddress" class="label-left"></gui-input>
					<gui-input type="text" label="City" name="city" v-model="quoteInfo.venue.city" class="label-left"></gui-input>
					<gui-input type="text" label="State" name="state" v-model="quoteInfo.venue.state" class="label-left"></gui-input>
					<gui-input type="text" label="Zip Code" mask="_____" name="zipCode" v-model="quoteInfo.venue.zipCode" class="label-left"></gui-input>
					<gui-input type="text" label="Is parking available at the venue?" label-width="250px" name="hasParking" v-model="quoteInfo.venue.isParkingAvailable" class="label-left" :options="yesNo"></gui-input>
					<gui-input type="text" label="Is it wheelchair accessible (for harp transportation)?" label-width="250px" name="isWheelchairAccessable" v-model="quoteInfo.venue.isWheelChairAccessable" class="label-left" :options="yesNo"></gui-input>
					<gui-input type="text" label="Is the event indoor or outdoor?" label-width="250px" name="indoorOutdoor" v-model="quoteInfo.venue.indoorOutdoor" class="label-left" :options="indoorOutdoor"></gui-input>
				</div>
				
				<div class="gw-field-group" v-show="displayExtraFields">
					<h5 class="gw-field-group-header">Additional Info</h5>
					<gui-input type="text" label="How did you hear about us?" label-width="200px" name="how" v-model="quoteInfo.how" class="label-left" :options="howOptions"></gui-input>
					<gui-input type="textarea" label="Any questions, concerns, or special requests?" name="extraInfo" v-model="quoteInfo.comments"></gui-input>
				</div>
				
				<div>
					<button type="button" class="gw-btn success" v-show="!displayVenueFields" @click="displayVenueFields = true">Add Venue Info</button>
					<!-- <button type="button" class="gw-btn success" v-show="!displayExtraFields" @click="displayExtraFields = true">Add Extra Info</button> -->
				</div>
			</form>
			
			<div slot="footer">
				<button type="button" class="gw-btn blue" @click="submitQuote">Request Quote</button>
				<button type="button" class="gw-btn" @click="closeDialog">Cancel</button>
			</div>
		</gui-dialog>
</template>

<script>
import { GuiInput, GuiDialog, GuiCheckbox } from 'gooey-ui'

export default {
	name: 'QuoteDialog',
	
	components: {
		GuiDialog,
		GuiInput,
		GuiCheckbox
	},
	
	data() {
		return {
			quoteInfo: {
				contact: {},
				wedding: {},
				memorial: {},
				venue: {}
			},
			displayVenueFields: false,
			displayExtraFields: true,
			eventTypes: ['Wedding Ceremony','Cocktail Hour','Dinner','Memorial Service','Open House','Other'],
			yesNo: ['Yes','No'],
			indoorOutdoor: ['Indoor','Outdoor'],
			howOptions: ['Another Client','WeddingWire.com','TheKnot.com','Bridal Expo','Search Engine','Other'],
			error: {
				name: false,
				email: false,
				date: false
			}
		}
	},
	
	props: ['display-dialog'],
	
	computed: {
		dropdownClass() {
			return {
				'gw-glyph-uparrow': this.$data.displayDropdown,
				'gw-glyph-downarrow': !this.$data.displayDropdown
			};
		}
	},
	
	methods: {
		// onInput: function(name) {
		// 	if(this.$refs[name].$refs.input.value.length > 0) {
		// 		this.$data.error[name] = false;
		// 	} else if(this.$refs[name].fields[name].touched) {
		// 		this.$data.error[name] = true;
		// 	}
		// },
		
		closeDialog: function() {
			this.$emit('close-dialog');
		},
		
		toggleDropdown: function(event) {
			event.preventDefault();
			this.$data.displayDropdown = !this.$data.displayDropdown;
		},
		
		submitQuote: function() {
			// console.log(this.$refs.quoteForm.children);
			fetch('/api/quote', {
				method: 'POST',
				mode: 'cors',
				cache: 'no-cache',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json'
				},
				redirect: 'follow',
				body: JSON.stringify(this.$data.quoteInfo)
			})
			.then(response => {
				this.closeDialog();
			});
			// this.$validator.validate().then(valid => {
			// 	if(valid) {
			// 		console.log(valid, arguments);
			// 	} else {
			// 		console.log(this.$validator.errors.items[0]);
			// 		let name = this.$validator.errors.items[0].field;
			// 		let field = this.$el.querySelector('[name="' + name + '"]');
			// 		let ref = this.$refs[name];
			// 		console.log(field);
			// 		console.log(ref);
			// 		// ref.$refs.input.dispatchEvent(new InputEvent('1'));
			// 		// ref.fields.name.validated = true;
			// 		ref.fields.name.dirty = true;
			// 		ref.fields.name.pristine = false;
			// 		ref.fields.name.changed = true;
			// 		ref.fields.name.touched = true;
			// 		this.$data.error[name] = true;
					
			// 		console.log(ref);
			// 		field.scrollIntoView();
			// 		field.focus();
			// 	}
			// });
		}
	}
}
</script>

<style>
.gw-dropdown-arrow {
	/* width: 20px;
	height: 20px; */
	display: flex;
	align-items: center;
	justify-content: center;
}

.gw-dialog-wrapper .gw-dialog.gw-box {
	width: auto;
}
</style>
